import { Table } from '@fortress-technology-solutions/fortress-component-library/Organisms_Fortress';
import useBaseTableProps from '../../../../hooks/useBaseTableProps';
import { useManageCentralizedReports } from '../../hooks';
import { NAME } from '../../constants';

const ReportsTab = ({
  organizationId,
  userId,
  username,
  onSelectReport,
  openViewHistoryModal,
  tableHeight,
  newlyGeneratedReports,
  setNewlyGeneratedReports,
}) => {
  const baseTableProps = useBaseTableProps();

  const {
    allColumnsHidden,
    columnOptions,
    count,
    dateState,
    filterState,
    filterTypeState,
    filteredHeaders,
    handleColumnChange,
    handleDateSubmit,
    handleFilterChange,
    handleFilterTypeChange,
    handleSortChange,
    isLoading,
    name,
    order,
    orderBy,
    rows,
    selectedColumns,
    totalCount,
  } = useManageCentralizedReports({
    NAME,
    organizationId,
    userId,
    username,
    onSelectReport,
    openViewHistoryModal,
    newlyGeneratedReports,
    setNewlyGeneratedReports,
  });

  return (
    <Table
      {...baseTableProps}
      height={tableHeight}
      allColumnsHidden={allColumnsHidden}
      columnOptions={columnOptions}
      count={count}
      dateState={dateState}
      filterState={filterState}
      filterTypeState={filterTypeState}
      handleColumnChange={handleColumnChange}
      handleDateSubmit={handleDateSubmit}
      handleFilterChange={handleFilterChange}
      handleFilterTypeChange={handleFilterTypeChange}
      handleSortChange={handleSortChange}
      headers={filteredHeaders}
      isLoading={isLoading}
      name={name}
      order={order}
      orderBy={orderBy}
      rows={rows}
      selectedColumns={selectedColumns}
      totalCount={totalCount}
    />
  );
};

export default ReportsTab;
